import { useEffect, useState } from 'react';

import { useAppSelector } from '../../../app/redux/hooks';
import { selectVersion, Version } from '../../../features/config';
import './version.css';

export default function VersionCheck() {
  const currentVersion = useAppSelector(selectVersion);

  const [showVersionUpdate, setShowVersionUpdate] = useState(false);

  useEffect(() => {
    const ivl = setInterval(() => {
      if (currentVersion) {
        fetch('/version.json')
          .then((res) => res.json())
          .then((data: Version) => {
            if (data.version !== currentVersion.version) setShowVersionUpdate(true);

            return;
          })
          .catch((err) => {
            console.error('Error fetching version:', err);
          });
      }
    }, 5 * 60 * 1000); // every 5 minutes
    return () => clearInterval(ivl);
  });

  if (showVersionUpdate) {
    return (
      <div className="version-container">
        <div className="version-box">
          <div className="version-header">New Version Available</div>
          <div className="version-content">
            <p className="version-text">
              A new version of POS is available. <br />
              <br />
              Please restart.
            </p>
            <br />
            <button className="version-button" onClick={() => window.location.reload()}>
              Restart
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <></>;
}
